import cloudbase from "@cloudbase/js-sdk";

const app = cloudbase.init({
  env: 'project-museum-6gojwrvc77da9aee',
  timeout: 5000
});
// 根据_id获取图片
export function getImgToCloud(params) {
  /* params : cloud://project-museum-6gojwrvc77da9aee.7072-project-museum-6gojwrvc77da9aee-1257201937/Picture_All_Course/ _id /PosterPicture/_id -0.jpg
      name: Course / Roads
      ids: Array [_id]
  */
  if (params.ids.length == 0) {
    return []
  }
  const list = []
  if (params.name == 'Course') {// 课程
    params.ids.forEach(id => {
      list.push(`cloud://project-museum-6gojwrvc77da9aee.7072-project-museum-6gojwrvc77da9aee-1257201937/Picture_All_Course/${id}/PosterPicture/${id}-0.jpg`)
    })
  } else {
    params.ids.forEach(id => {
      list.push(`cloud://project-museum-6gojwrvc77da9aee.7072-project-museum-6gojwrvc77da9aee-1257201937/Picture_All_Roads/${id}/PosterPicture/${id}-0.jpg`)
    })
  }
  return app
    .getTempFileURL({
      fileList: list
    });
}
// 根据不同的类别获取图片
export function getImgsToCloud(params) {
  /* 
  id
  count
  type： 'Course'
  filed： PublicityPicture
   */
  const list = [];
  for (let index = 0; index < params.count; index++) {
    list.push(`cloud://project-museum-6gojwrvc77da9aee.7072-project-museum-6gojwrvc77da9aee-1257201937/${params.type == 'Course' ? 'Picture_All_Course' : 'Picture_All_Roads'}/${params.id}/${params.filed}/${params.id}-${index}.jpg`)
  }
  // console.log(list)
  return app
    .getTempFileURL({
      fileList: list
    });
}

// 获取所有路线
function getAllRoads(params) {
  const where = params.where ? params.where : {}
  const db = params.$TCB_App.database();
  const AllRoads = db.collection("DataBase_All_Roads");
  return AllRoads.limit(params.limit).skip(params.skip).orderBy("EditDate", "desc").where(where).get();
}
// 获取所有课程
function getAllCourse(params) {
  const where = params.where ? params.where : {}
  const db = params.$TCB_App.database();
  const AllCourse = db.collection("DataBase_All_Course");
  return AllCourse.limit(params.limit).skip(params.skip).orderBy("EditDate", "desc").where(where).get();
}
export function getIndexInfoList(data) {
  /* params:
    $TCB_App 
    limit:20,
    skip: 20
  */
  let params = {
    $TCB_App: {},
    limit: 20,
    skip: 0
  }
  params = Object.assign(params, data)
  const get1 = getAllRoads(params).then(res => {
    const list = res.data
    return list
  })
  const get2 = getAllCourse(params).then(res => {
    const list = res.data
    return list
  })

  const getIds = function (list, slefType) {
    const ids = list.map(item => {
      item.slefType = slefType
      item.tempFileURL = ''
      return item._id
    })
    if (ids.length > 0) {
      return ids
    }
    return list
  }
  return Promise.all([get1, get2]).then(arr => {
    const ids1 = getIds(arr[0], 'Roads')
    const ids2 = getIds(arr[1], 'Course')

    const get3 = getImgToCloud({
      name: 'Roads',
      ids: ids1
    })
    const get4 = getImgToCloud({
      name: 'Course',
      ids: ids2
    })
    return Promise.all([get3, get4]).then(res => {
      const arr0 = arr[0]
      const arr1 = arr[1]
      if (arr0.length > 0) {
        arr0.map((item, index) => {
          if (res[0].fileList[index].code === "SUCCESS") {
            item.tempFileURL = res[0].fileList[index].tempFileURL
          }
          return item
        })
      }
      if (arr1.length > 0) {
        arr1.map((item, index) => {
          if (res[1].fileList[index].code === "SUCCESS") {
            item.tempFileURL = res[1].fileList[index].tempFileURL
          }
          return item
        })
      }
      return [arr0, arr1]
    })
  })
}
